import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { editReportTemplateByIdFailed, editReportTemplateByIdSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* editReportTemplateById(action) {
  try {
    const { id, values } = action.payload;
    if (!id) { throw new Error('ID not found'); }
    const url = `${BACKEND_URL}/resources/report-templates/${action.payload.id}`;
    const response = yield makeRequest(url, values, action, 'PUT', true);
    if (response.status === OK) {
      yield put(editReportTemplateByIdSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      const data = yield getBodyJson(response);
      yield put(editReportTemplateByIdFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(editReportTemplateByIdFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
